import T from 'prop-types';
import React, { Fragment } from 'react';
import Iframe from '../Iframe';

const DREAMBROKER_URL = (videoId) => `https://dreambroker.com/${videoId}`;

const Video = ({
  Heading,
  VideoTitle,
  VideoId,
  VideoText,
  IsMediaFlowPro,
  IsDreamBroker,
  IsQbrick,
  isH3,
  IsStandingVideo,
  hideTitle,
  hideCaption,
  isGallery,
  Link,
  InternalLinkName,
  LinkText,
  CurrentPageProps,
}) => {
  if (!VideoId) return null;

  let videoUrl = null;
  videoUrl =
    (IsDreamBroker && DREAMBROKER_URL(VideoId)) ||
    (IsQbrick && VideoId) ||
    (IsMediaFlowPro && VideoId);

  const addTimeUpdateParam = (videourl) => {
    if (
      (/play\.mediaflowpro\.com/.test(videourl) ||
        /play\.mediaflow\.com/.test(videourl)) &&
      !/(\?|&)timeupdate\b/.test(videourl)
    ) {
      const separator = videourl.includes('?') ? '&' : '?';
      videourl += `${separator}timeupdate`;
    }
    return videourl;
  };

  const dataPrintSidebarTitle =
    Heading || CurrentPageProps?.Content?.Translations?.videoblock || 'Film';

  return (
    <Fragment>
      <div
        className="c-video__wrapper"
        data-print-sidebar-title={dataPrintSidebarTitle}
      >
        <Iframe
          title={VideoTitle}
          data-matomo-title={VideoTitle}
          className="c-video"
          src={addTimeUpdateParam(videoUrl)}
          caption={VideoText}
          heading={Heading}
          isH3={isH3}
          isStandingVideo={IsStandingVideo}
          hideCaption={hideCaption}
          hideTitle={hideTitle}
          isGallery={isGallery}
          galleryLink={{ Link, LinkText: LinkText || InternalLinkName }}
        />
        <div className="c-video__print-info print-only">
          <span>Video: {videoUrl}</span>
          <p>{VideoText}</p>
        </div>
      </div>
    </Fragment>
  );
};

Video.propTypes = {
  Heading: T.string,
  VideoTitle: T.string,
  /** Component will return `null` if no VideoId is provided */
  VideoId: T.string,
  VideoText: T.string,
  isH3: T.string,
};

export default Video; // killed the radio star
